export default "__VITE_ASSET__jEmwx7pr__"